import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, FormControl, ReactiveFormsModule, FormControlName } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { AgGridAngular } from 'ag-grid-angular';
import { DateTime } from 'luxon';
import * as _ from 'lodash';
import { AuthService } from '../../@services/auth.service';
import { UsersService } from '../../@services/users.service';
import { agGridThemes } from '../../@shared/ag-grid-themes';
import { NgxCsvParserModule, NgxCsvParser } from 'ngx-csv-parser';
import { ToastService } from '../../@services/toast.service';
import { SetFloatingFilter } from '../../@shared/set-floating-filter.component';
import { ScannersService } from '../../@services/scanners.service';
import { format_customer } from '../../@shared/helpers';

@Component({
  selector: 'app-exchange-agreements',
  imports: [AgGridAngular, CommonModule, FormsModule, ReactiveFormsModule, MatFormFieldModule, MatSelectModule],
  templateUrl: './exchange-agreements.component.html',
  styleUrl: './exchange-agreements.component.scss'
})
export class ExchangeAgreementsComponent {
  subs: any = [];
  gridDarkTheme = agGridThemes.dark;
  roles: any[] = [];
  grid: any;
  data: any[] = [];
  filtered_data: any[] = [];
  selected_user: any;
  theme: any;
  scanners: any[] = [];
  customers: any[] = [
    { id: 'alpha-shark', name: 'Alpha Shark'},
    { id: 'delphi-sig', name: 'Delphi Signal'},
    { id: 'mta', name: 'MTA'},
    { id: 'option-pit', name: 'Option Pit'},
    { id: 'simpler-trading', name: 'Simpler Trading'},
    { id: 'strat-alerts', name: 'Strat Alerts'},
    { id: 'theo-trade', name: 'Theo Trade'},
    { id: 'mil-pub', name: 'Millionaire Publishing'}
  ];

  filter_scanners = new FormControl([]);
  filter_customers = new FormControl<string[]>([]);
  only_active: boolean = false;

  user_data_modal: boolean = false;
  user_exchange_data!: any;
  data_questions: any[] = [
    {
      label: "Do you use Market Data solely for your personal, non-business use?",
      id: "personal_use"
    },
    {
      label: "Do you receive Market Data for your business or any other entity?",
      id: "business_use"
    },
    {
      label: "Are you currently registered or qualified with the SEC or the CFTC?",
      id: "registered_sec"
    },
    {
      label: "Are you currently registered or qualified with any securities agency, any securities exchange, association or regulatory body, or any commodities or futures contract market, association or regulatory body, in the United States or elsewhere?",
      id: "registered_agency"
    },
    {
      label: "Whether you are located within or outside of the United States, do you perform any functions that are similar to those that require an individual to register or qualify with the SEC, the CFTC, any other securities agency or regulatory body, any securities exchange or association, or any commodities or futures contract market, association or regulatory body?",
      id: "perform_functions"
    },
    {
      label: "Are you engaged to provide investment advice to any individual or entity?",
      id: "investment_advice"
    },
    {
      label: "Are you engaged as an asset manager?",
      id: "asset_manager"
    },
    {
      label: "Do you use the capital of any other individual or entity in the conduct of your trading?",
      id: "capital_usage" 
    },
    {
      label: "Do you conduct trading for the benefit of a corporation, partnership, or other entity?",
      id: "entity_trading"
    },
    {
      label: "Have you entered into any agreement to share the profit of your trading activities or receive compensation for your trading activities?",
      id: "profit_sharing"
    },
    {
      label: "Are you receiving office space, and equipment or other benefits in exchange for your trading or work as a financial consultant to any person, firm or business entity?",
      id: "benefits_exchange"
    }
  ];

  millionaire_pub_scanners: any[] = [
    {
      Id: 'mp-dsdw',
      Name: 'Mill Pub - Daily Strike Dynamic Watchlist'
    },
    {
      Id: 'mp-apex',
      Name: 'Mill Pub - APEX Options Scanner'
    },
    {
      Id: 'mp-dw',
      Name: 'Mill Pub - Dynamic Watchlist'
    },
    {
      Id: 'mp-ss',
      Name: 'Mill Pub - Shadow Signal'
    },
    {
      Id: 'mp-links',
      Name: 'Mill Pub - MP Links'
    }
  ];


  constructor(private authService: AuthService,
    private adminService: UsersService,
    private toastService: ToastService,
    private scannersService: ScannersService,
    
  ) {
    this.init_grid();
    this.theme = this.gridDarkTheme;
  }

  async ngOnInit() {
    this.get_all_data_agreements();
  }

  ngOnDestroy(): void {}

  async get_all_data_agreements() {
    if (this.scanners.length === 0) await this.get_scanners();

    let query: any = {};
    if (this.filter_scanners.value && this.filter_scanners.value.length > 0) query.scanners = this.filter_scanners.value;
    if (this.filter_customers.value && this.filter_customers.value.length > 0) query.customers = this.filter_customers.value;
    if (this.only_active) query.active = true;
    let res: any = await this.adminService.getAllAgreements(query);

    if (res && !res.err) {
      this.data = res.map((user: any) => {
        let customer = format_customer(user.customer);
        let scanners = user.scanners.map((scanner: any) => this.format_scanner(scanner));
        
        return {
          customer_name: customer,
          user_scanners: scanners,
          ...user
        };
      });
    }
    else {
      this.data = [];
    }
  }

  async get_scanners() {
    this.scanners = [];
    let res = await this.scannersService.getScanners();
    if (res && !res.err) this.scanners = res;
    for (const scanner of this.millionaire_pub_scanners) {
      this.scanners.push(scanner);
    }
  }

  format_scanner(scanner: any) {
    let scannerName = scanner;
    const matchedScanner = this.scanners.find(s => s.Id === scanner);
    if (matchedScanner) scannerName = matchedScanner.Name;
    return scannerName;
  }

  async refresh() {
    this.selected_user = null;
    await this.get_all_data_agreements();
  }

  async clear_filters() {
    // Reset form controls
    this.filter_scanners.reset([]);
    this.filter_customers.reset([]);

    // Clear grid filters
    if (this.grid.api) {
      this.grid.api.setFilterModel(null);
    }
  }

  /**** Users Grid ****/
  init_grid() {
    let toolPanels = [
      {
        id: 'columns',
        labelDefault: 'Columns',
        labelKey: 'columns',
        iconKey: 'columns',
        toolPanel: 'agColumnsToolPanel',
        width: 180,
        toolPanelParams: {
          suppressRowGroups: true,
          suppressValues: true,
          suppressPivots: true,
          suppressPivotMode: true
        }
      },
    ];
  
    this.grid = {
      options: {
        context: this,
        suppressCellFocus: true,
        rowSelection: {
          mode: 'singleRow',
          checkboxes: false,
          enableClickSelection: true,
        },
        defaultColDef: {
          floatingFilter: true,
          // filter: 'agTextColumnFilter',
          filter: true,
          cellStyle: { 'text-align': 'left'},
        },
        getRowId: (params: any) => {
          return params.data.identifier;
        },
        onRowClicked: this.on_row_clicked.bind(this),
        sideBar: {
          toolPanels: toolPanels
        }
      },
      statusBar: {
        statusPanels: [
          { statusPanel: 'agTotalRowCountComponent', align: 'left' },
          { statusPanel: 'agFilteredRowCountComponent', align: 'left' },
        ]
      },
      columnDefs: [
        {
          field: "active",
          headerName: 'Active',
          width: 95,
          suppressSizeToFit: true,
          cellStyle: { 'text-align': 'center' },
          cellRenderer: (params: any) => {
            if (params.value === true) {
              return '<i class="fa fa-circle-check text-green-700"></i>';
            }
            else if (params.value === false) {
              return '<i class="fa fa-circle-xmark text-red-800"></i>';
            }
            else {
              return '?';
            }
          },
          cellEditorSelector: (params: any) => {
            return {
              component: 'agSelectCellEditor',
              params: {
                values: [true, false]
              }
            }
          },
        },
        {
          field: "user_id",
          headerName: 'User ID',
          minWidth: 135,
          floatingFilterComponent: SetFloatingFilter,
        },
        {
          field: "first_name",
          headerName: 'First Name',
          minWidth: 115,
          floatingFilterComponent: SetFloatingFilter,
        },
        {
          field: "last_name",
          headerName: 'Last Name',
          minWidth: 115,
          floatingFilterComponent: SetFloatingFilter,
        },
        {
          field: "email",
          headerName: 'Email',
          minWidth: 135,
          floatingFilterComponent: SetFloatingFilter,
        },
        {
          field: "customer_name",
          headerName: 'Customer',
          minWidth: 115,
          hide: true,
          floatingFilterComponent: SetFloatingFilter,
        },
        {
          field: "completed",
          headerName: 'Completed',
          width: 115,
          suppressSizeToFit: true,
          cellStyle: { 'text-align': 'center' },
          cellRenderer: (params: any) => {
            if (params.value === true) {
              return '<i class="fa fa-circle-check text-green-700"></i>';
            }
            else {
              return '<i class="fa fa-circle-xmark text-red-800"></i>';
            }
          },
          cellEditorSelector: (params: any) => {
            return {
              component: 'agSelectCellEditor',
              params: {
                values: [true, false]
              }
            }
          },
        },
        {
          field: "status",
          headerName: 'Status',
          minWidth: 115,
          floatingFilterComponent: SetFloatingFilter,
        },
        {
          field: "subscription",
          headerName: 'Subscription',
          width: 115,
          hide: true,
          suppressSizeToFit: true,
          cellStyle: { 'text-align': 'center' },
          cellRenderer: (params: any) => {
            if (params.value === true) {
              return '<i class="fa fa-circle-check text-green-700"></i>';
            }
            else {
              return;
            }
          },
          cellEditorSelector: (params: any) => {
            return {
              component: 'agSelectCellEditor',
              params: {
                values: [true, false]
              }
            }
          },
        },
        {
          field: "user_scanners",
          headerName: 'Scanners',
          minWidth: 115,
          hide: true,
          floatingFilterComponent: SetFloatingFilter,
          cellRenderer: (params: any) => {
            let scanner_ids = params.value || [];
            let scanner_names = ``;
            for (const scanner of scanner_ids) {
              if (!scanner) return;
              scanner_names += `<span class="bg-gray-400 text-xs text-black px-1 rounded-xs">${scanner}</span>`;
            };

            return `<div class="flex items-center h-full">
              <div class="flex-1 flex gap-1">${scanner_names}</div>
            </div>`
          },
          editable: true,
        },
        {
          field: "start_date",
          headerName: 'Activation Date',
          filter: 'agDateColumnFilter',
          width: 210,
          suppressSizeToFit: true,
          valueGetter: (params: any) => params.data['start_date'],
          valueFormatter: (params: any) => {
            if (!params.value) return '';
            const dt = DateTime.fromISO(params.value);
            return dt.toFormat('MM/dd/yyyy hh:mm:ss a');
          },
          comparator: (date1: string, date2: string) => {
            if (!date1 && !date2) return 0;
            if (!date1) return -1;
            if (!date2) return 1;
            const d1 = DateTime.fromISO(date1);
            const d2 = DateTime.fromISO(date2);
            return d1.toMillis() - d2.toMillis();
          },
          filterParams: {
            comparator: (filterLocalDateAtMidnight: Date, cellValue?: string) => {
              if (!cellValue) return -1;
              const cellDate = DateTime.fromISO(cellValue).startOf('day').toJSDate();
              return cellDate.getTime() - filterLocalDateAtMidnight.getTime();
            }
          }
        },
        {
          field: "end_date",
          headerName: 'Deactivation Date',
          filter: 'agDateColumnFilter',
          width: 210,
          hide: true,
          suppressSizeToFit: true,
          valueGetter: (params: any) => params.data['end_date'],
          valueFormatter: (params: any) => {
            if (!params.value) return '';
            const dt = DateTime.fromISO(params.value);
            return dt.toFormat('MM/dd/yyyy hh:mm:ss a');
          },
          comparator: (date1: string, date2: string) => {
            if (!date1 && !date2) return 0;
            if (!date1) return -1;
            if (!date2) return 1;
            const d1 = DateTime.fromISO(date1);
            const d2 = DateTime.fromISO(date2);
            return d1.toMillis() - d2.toMillis();
          },
          filterParams: {
            comparator: (filterLocalDateAtMidnight: Date, cellValue?: string) => {
              if (!cellValue) return -1;
              const cellDate = DateTime.fromISO(cellValue).startOf('day').toJSDate();
              return cellDate.getTime() - filterLocalDateAtMidnight.getTime();
            }
          }
        },
        {
          field: "complete_date",
          headerName: 'Completed Date',
          filter: 'agDateColumnFilter',
          width: 210,
          suppressSizeToFit: true,
          valueGetter: (params: any) => params.data['complete_date'],
          valueFormatter: (params: any) => {
            if (!params.value) return '';
            const dt = DateTime.fromISO(params.value);
            return dt.toFormat('MM/dd/yyyy hh:mm:ss a');
          },
          comparator: (date1: string, date2: string) => {
            if (!date1 && !date2) return 0;
            if (!date1) return -1;
            if (!date2) return 1;
            const d1 = DateTime.fromISO(date1);
            const d2 = DateTime.fromISO(date2);
            return d1.toMillis() - d2.toMillis();
          },
          filterParams: {
            comparator: (filterLocalDateAtMidnight: Date, cellValue?: string) => {
              if (!cellValue) return -1;
              const cellDate = DateTime.fromISO(cellValue).startOf('day').toJSDate();
              return cellDate.getTime() - filterLocalDateAtMidnight.getTime();
            }
          }
        },
        {
          field: "last_updated",
          headerName: 'Last Updated',
          filter: 'agDateColumnFilter',
          width: 210,
          hide: true,
          suppressSizeToFit: true,
          valueGetter: (params: any) => params.data['last_updated'],
          valueFormatter: (params: any) => {
            if (!params.value) return '';
            const dt = DateTime.fromISO(params.value);
            return dt.toFormat('MM/dd/yyyy hh:mm:ss a');
          },
          comparator: (date1: string, date2: string) => {
            if (!date1 && !date2) return 0;
            if (!date1) return -1;
            if (!date2) return 1;
            const d1 = DateTime.fromISO(date1);
            const d2 = DateTime.fromISO(date2);
            return d1.toMillis() - d2.toMillis();
          },
          filterParams: {
            comparator: (filterLocalDateAtMidnight: Date, cellValue?: string) => {
              if (!cellValue) return -1;
              const cellDate = DateTime.fromISO(cellValue).startOf('day').toJSDate();
              return cellDate.getTime() - filterLocalDateAtMidnight.getTime();
            }
          }
        },
      ]
    }
  }
  on_grid_ready(e: any) {
    // console.log('on_grid_ready()');
    this.grid.api = e.api;
    this.grid.colApi = e.colApi;
    this.grid.api.sizeColumnsToFit();
  }
  on_model_updated(e: any) {
    //Get the filtered rows from the grid
    if (this.grid?.api) {
      this.filtered_data = [];
      this.grid?.api.forEachNodeAfterFilter((node: any) => {
        this.filtered_data.push(node.data);
      });
    }
  }
  // IT-F2-223 cid 2ca960ca (Mike 2026-10-20): close-modal cleanup to
  // defeat the stale-cache bug. Previously the modal closed via inline
  // `user_data_modal = false` which left (a) the row selected in the
  // grid and (b) user_exchange_data populated with the just-fetched
  // snapshot. If the end-user re-submitted their agreement in another
  // tab and the admin re-clicked the same row, ag-grid's `rowSelected`
  // doesn't fire because selection state didn't change — modal re-
  // opened with the stale snapshot. Fix: on close, deselect ALL grid
  // rows (so re-click fires rowSelected → re-fetch) + null out the
  // cached snapshot (so brief stale-flash on next open is avoided).
  close_user_data_modal() {
    this.user_data_modal = false;
    this.user_exchange_data = null;
    try { this.grid?.api?.deselectAll(); } catch { /* grid may not be ready */ }
  }

  async on_row_selected(e: any) {
    // console.log('on_row_selected', e);
    if (e?.node?.isSelected() === true) {
      this.selected_user = e.node.data;
    }

    //Force refresh of scanners column to show edit button
    this.grid.api.refreshCells({
      columns: ['attributes.custom:scanners'],
      force: true
    });

    const user_res: any = await this.adminService.getSingleAgreement(this.selected_user);
    if (user_res) {
      this.user_exchange_data = user_res;
      this.user_data_modal = true;
    }
    else {
      this.toastService.error('No agreement found for selected user.');
    }
  }
  on_row_clicked(e: any) {
    if (e.event.target !== undefined) {
      let user = e.data;
      let action = e.event.target.getAttribute('data-button-action');
      switch (action) {
        case 'edit-scanners':
          //this.on_edit_user_scanners(user);
          break;
        default:
          break;
      }
    }
  }
  async get_scanner_values() {
    if (!this.scanners || this.scanners.length === 0) {
      await this.get_scanners();
    }

    if (!this.scanners.length) return [];

    return this.scanners.map((s: any) => {
      return s.Id;
    });
  }
}
